var _defs, _path, _path2, _path3, _path4, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrosoftLogo02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 609.68 127.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-9{fill:#fff;}.cls-2,.cls-9{font-size:44.66px;font-family:MicrosoftJhengHeiUIRegular, Microsoft JhengHei UI;}.cls-2{letter-spacing:-0.02em;}.cls-3{letter-spacing:-0.03em;}.cls-4{letter-spacing:-0.02em;}.cls-5{letter-spacing:-0.04em;}.cls-6{letter-spacing:0em;}.cls-7{letter-spacing:-0.05em;}.cls-8{letter-spacing:0.01em;}.cls-10{letter-spacing:-0.04em;}.cls-11{letter-spacing:-0.01em;}.cls-12{letter-spacing:0em;}.cls-13{letter-spacing:-0.01em;}.cls-14{letter-spacing:0em;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.9,57.9l-1.48-7.15a1.1,1.1,0,0,1,.25-.87L57,48.18a1.4,1.4,0,0,0,.27-.91,53.29,53.29,0,0,0-.5-8.32,69,69,0,0,0-19-36.44,1.72,1.72,0,0,0-2.93.14q-2.7,3.27-5.14,6.54A89.31,89.31,0,0,0,16,35.66,63.76,63.76,0,0,1,36.14.14a.55.55,0,0,1,.74,0C52.72,14.81,61.85,36.32,56.9,57.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M56.9,57.9c.15.79.44,1.25.86,1.38a.56.56,0,0,0,.67-.44v0l1.12-4.49c.24-.94.62-1,1.16-.29q4.53,6.33,9.48,12.79c2.33,3,1.86,7.46,1.43,11a.57.57,0,0,1-.57.49l-14.85.08a.55.55,0,0,0-.54.51l-.55,5.15a.57.57,0,0,1-.55.5l-9.3,0a1.13,1.13,0,0,0-1.13,1.08q-1.06,20.68-2,40.47c0,.78-.25,1.2-.65,1.27-.24,0-.47-.18-.51-.49,0,0,0,0,0-.07q-.56-12.85-2.4-70.33c0-.65-.27-.86-.77-.63a.84.84,0,0,0-.44.75l-2.42,53a1.11,1.11,0,0,1-.36.87.45.45,0,0,1-.56,0,1.11,1.11,0,0,1-.35-.83l-.95-24a.68.68,0,0,0-.48-.65,5.85,5.85,0,0,0-3.16,0,.68.68,0,0,0-.49.66q-.27,9-.62,17.9c-.1,2.54-1.24,2.67-1.5.09q-.93-9.15-1.93-18.27a.55.55,0,0,0-.55-.48l-5.48-.19a.59.59,0,0,1-.56-.54l-.42-4.81a.62.62,0,0,0-.51-.59c-5.23-1-10.92-.21-16.24-.39a.61.61,0,0,1-.57-.51A35.61,35.61,0,0,1,.33,69a1.72,1.72,0,0,1,.39-.88L12.61,54c.21-.25.36-.22.46.1l1.64,5.14a.52.52,0,0,0,.47.4l.18,0a.22.22,0,0,0,.17-.24A22.83,22.83,0,0,0,15.4,55,47.18,47.18,0,0,1,16,35.66,89.31,89.31,0,0,1,29.67,9.19q2.45-3.27,5.14-6.54a1.72,1.72,0,0,1,2.93-.14A69,69,0,0,1,56.76,39a53.29,53.29,0,0,1,.5,8.32,1.4,1.4,0,0,1-.27.91l-1.32,1.7a1.1,1.1,0,0,0-.25.87ZM45.48,29.82A8.78,8.78,0,1,0,36.7,38.6,8.78,8.78,0,0,0,45.48,29.82Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.82,15.26h1.37c.28,0,.51.07.51.17v65.7c0,.09-.23.17-.51.17H92.82c-.28,0-.51-.08-.51-.17V15.43C92.31,15.33,92.54,15.26,92.82,15.26Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.48,29.82A8.78,8.78,0,1,1,36.7,21,8.78,8.78,0,0,1,45.48,29.82Zm-1.2-.11a7.57,7.57,0,1,0-7.57,7.57A7.57,7.57,0,0,0,44.28,29.71Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(137.84 96.69)"
  }, "Mic", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 74.64,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 89.86,
    y: 0
  }, "os"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 136.89,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 163.43,
    y: 0
  }, "f"), /*#__PURE__*/React.createElement("tspan", {
    x: 178.42,
    y: 0
  }, "t for "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 272.06,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 295.29,
    y: 0
  }, "ta"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 334.42,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 351.67,
    y: 0,
    xmlSpace: "preserve"
  }, "tups   "))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(137.42 44.23)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    x: 25.06,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 53.23,
    y: 0
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 87.6,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 112.77,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 128.75,
    y: 0
  }, "ed by"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftLogo02);
export default __webpack_public_path__ + "static/media/microsoft_logo-02.d207e6d313ba0367144f98441a6b4a9a.svg";
export { ForwardRef as ReactComponent };